export default "__VITE_ASSET__wh6fXr6a__"